import React from 'react';

const ManagerDashboardPageConfig = {
	settings: {
		layout: {
			config: {
				adminPage: true,
			},
		},
	},
	routes: [
		{
			path: '/manager/dashboard',
			exact: false,
			component: React.lazy(() => import('./ManagerDashboardPage')),
		},
	],
};

export default ManagerDashboardPageConfig;
